const serverDateHandler = () => {
  let date = ''
  const setDate = (inDate: string) => {
    date = inDate;
  }
  const getDate = () => date;
  return { getDate, setDate }
}

export default serverDateHandler();